/* eslint-disable max-len */
// import { COMPANY_BANK_STATEMENTS, COMPANY_INVOICES, PERSONAL_BANK_STATEMENTS } from "../constants";

// const monthDiff = (dateFrom, dateTo) => {
//   return (
//     dateTo.getMonth() - dateFrom.getMonth() + 12 * (dateTo.getFullYear() - dateFrom.getFullYear())
//   );
// };

/**
 * Validates if a document is required based on Authorized Hawala Service Provider
 * @param {string} uniqueId - Document unique identifier
 * @param {Object} orgKYCDetails - KYC information
 * @returns {boolean} - Whether the document is required
 */
const isHawalaRequired = (uniqueId, orgKYCDetails) => {
  if (uniqueId === "RODOC101") {
    return orgKYCDetails?.anticipatedTransactionsDetails?.isCompanyAuthorizedHawala === "Yes";
  }
  return null;
};

/**
 * Validates if address document is required based on visit information
 * @param {string} uniqueId - Document unique identifier
 * @param {Object} organizationInfoRO - Organization RO information
 * @returns {boolean} - Whether the document is required
 */
const isAddressDocumentRequired = (uniqueId, organizationInfoRO) => {
  if (uniqueId === "RODOC21") {
    const visits = organizationInfoRO?.visit || [];
    const hasAddressOfPlaceMet = Array.isArray(visits)
      ? visits.some(v => (v?.addressOfPlaceMet || "").trim().length > 0)
      : false;
    return hasAddressOfPlaceMet;
  }
  return null;
};

/**
 * Validates if location document is required based on coordinates
 * @param {string} uniqueId - Document unique identifier
 * @param {Object} organizationInfo - Organization information
 * @returns {boolean} - Whether the document is required
 */
const isLocationDocumentRequired = (uniqueId, organizationInfo) => {
  if (uniqueId === "DOC38") {
    return (
      organizationInfo.addressDetails.latitude === "" &&
      organizationInfo.addressDetails.longitude === ""
    );
  }
  return null;
};

/**
 * Validates if CV document is required for stakeholder
 * @param {string} uniqueId - Document unique identifier
 * @param {string} stakeHolderIndex - Stakeholder index
 * @param {Array} signatories - Array of signatories
 * @returns {boolean} - Whether the document is required
 */
const isCVDocumentRequired = (uniqueId, stakeHolderIndex, signatories) => {
  if (uniqueId === "DOC43") {
    const indexArr = stakeHolderIndex.split("_");
    const signatoryIndex = indexArr[0];

    if (!signatories[signatoryIndex]) {
      return false;
    }

    const signatory = signatories[signatoryIndex];
    return signatory.kycDetails.isUploadCV === true && signatory.isShareholderACompany === false;
  }
  return null;
};

// EID validation report requirement
const isEIDValidationRequired = (uniqueId, organizationInfoRO, stakeHolderIndex) => {
  if (uniqueId === "ADDRODOC49" || uniqueId === "RODOC49") {
    const eligibleList = organizationInfoRO?.siteVisitPostEligibility;
    if (!Array.isArray(eligibleList) || eligibleList.length === 0) return false;
    if (stakeHolderIndex) {
      const idxArr = stakeHolderIndex.split("_");
      const match = eligibleList.find(e => e.signatoryId === idxArr[1]);
      return !!match;
    }
    return false;
  }
  return null;
};

export const documentValidation = (
  doc,
  organizationInfo,
  organizationInfoRO,
  orgKYCDetails,
  signatories,
  stakeHolderIndex
) => {
  // const otherUAEBankAccountExist =
  //   orgKYCDetails.otherBankingRelationshipsInfo.otherUAEBankAccountExist;
  // const outsideUAEBankAccountExist =
  //   orgKYCDetails.otherBankingRelationshipsInfo.outsideUAEBankAccountExist;
  // const otherBankingRelation = otherUAEBankAccountExist || outsideUAEBankAccountExist;
  // if (type === COMPANY_BANK_STATEMENTS && otherBankingRelation === false) {
  //   required = false;
  // } else if (type === PERSONAL_BANK_STATEMENTS && otherBankingRelation === true) {
  //   required = false;
  // } else if (type === COMPANY_INVOICES) {
  //   const licenseIssueDate = new Date(organizationInfo.licenseIssueDate);
  //   const lengthOfBusiness = monthDiff(licenseIssueDate, new Date());
  //   required = lengthOfBusiness < 6 ? false : true;
  // }
  let { required, uniqueId } = doc;

  // Check Hawala document
  const hawalaRequired = isHawalaRequired(uniqueId, orgKYCDetails);
  if (hawalaRequired !== null) {
    return hawalaRequired;
  }

  // Check address documents
  const addressRequired = isAddressDocumentRequired(uniqueId, organizationInfoRO);
  if (addressRequired !== null) {
    return addressRequired;
  }

  // Check location documents (only when no stakeholder index)
  if (!stakeHolderIndex) {
    const locationRequired = isLocationDocumentRequired(uniqueId, organizationInfo);
    if (locationRequired !== null) {
      return locationRequired;
    }
  }

  // Check CV documents (only when stakeholder index exists)
  if (stakeHolderIndex) {
    const cvRequired = isCVDocumentRequired(uniqueId, stakeHolderIndex, signatories);
    if (cvRequired !== null) {
      return cvRequired;
    }
  }

  // Check EID validation report requirement
  const eidRequired = isEIDValidationRequired(uniqueId, organizationInfoRO, stakeHolderIndex);
  if (eidRequired !== null) {
    return eidRequired;
  }

  return required;
};
